import { Box, Button, SimpleGrid, Heading, Text, HStack, Flex } from "@chakra-ui/react";

const modulesData = [
  { title: "Smart_Asset", description: "Donec ut nibh quis velit venenatis consectetur id sit amet lacus." },
  { title: "Project_Tracker", description: "Donec ut nibh quis velit venenatis consectetur id sit amet lacus." },
  { title: "Finance_Manager", description: "Donec ut nibh quis velit venenatis consectetur id sit amet lacus." },
  { title: "HR_System", description: "Donec ut nibh quis velit venenatis consectetur id sit amet lacus." },
  { title: "Inventory_Control", description: "Donec ut nibh quis velit venenatis consectetur id sit amet lacus." },
  { title: "Customer_Portal", description: "Donec ut nibh quis velit venenatis consectetur id sit amet lacus." },
];

const Modules = () => {
  return (
    <Box flex="1" pt="40px" px="8">
      {/* Title */}
      <Flex justify="space-between" align="center" mb={6}>
        <Text fontSize="30px" color="#101828">
        Your modules
        </Text>
      </Flex>

      {/* SimpleGrid for Cards */}
      <SimpleGrid templateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }} gap={6}>
        {modulesData.map((module, index) => (
          <Box 
            key={index} 
            p={4} 
            border="1px solid #ccc" 
            borderRadius="md"
          >
            {/* Title & Button on the same line */}
            <HStack justify="space-between" mb={4}>
                {/* Rectangle */}
                <HStack>
                <Box 
                  width="36px" 
                  height="36px" 
                  borderRadius="6px" 
                  backgroundColor="#d7d7d7" 
                  boxSizing="border-box"
                />
              <Heading fontSize="14px" color="#475467" fontWeight="semibold">{module.title}</Heading>
              </HStack>
              <Button fontSize="14px" backgroundColor="#1e98d7" color=" #ffffff" fontWeight="semibold" width="88px" height="25px">Open</Button>
            </HStack>

            {/* Description below */}
            <Text fontSize="12px" color="#475467">{module.description}</Text>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default Modules;
